module.exports = __webpack_public_path__ + "static/media/powered-by-ngc.d03d7e28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/powered-by-ngc.svg
// module id = 547
// module chunks = 0